<template>
    <div class="home_wrap">
        <div :style="{width:pdf_div_width,margin:'0 auto'}">
            <canvas v-for="page in pdf_pages" :widths="width_img" :heights="height_img" @click="bigImg" :id="'the_canvas'+page" :key="page" :index="page"></canvas>
        </div>
        <Photo class="img_big" :items="items" v-if="bigImg_show" @show="close" />
    </div>
</template>

<script>
import Photo from "../../components/PhotoSwipe.vue"
/* let PDFJS = require('pdfjs-dist');
PDFJS.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker.entry.js"); */
export default {
    components: {
        Photo
    },
    data () {
        return {
            pdf_scale: 1.0,//pdf放大系数
            pdf_pages: [],
            pdf_div_width: '',
            pdf_src: null,
            items: [{
                src: '',
                w: 0,
                h: 0,
            },],
            bigImg_show: false,
            list: [],
            width_img: "",
            height_img: "",
        }
    },
    mounted () {
        this.get_pdfurl()
    },
    methods: {
        get_pdfurl () {
            this.pdf_src = 'https://oss.eventnet.cn/H5/df/03-2020%E4%BE%9B%E5%BA%94%E5%95%86%E5%B9%B4%E4%BC%9AMQA%E6%8A%A5%E5%91%8A_CN.pdf'
            this._loadFile(this.pdf_src)
            return
        },
        _loadFile (url) {
            let that = this;
            let loadingTask = PDFJS.getDocument(url)
            loadingTask.promise.then((pdf) => {
                that.pdfDoc = pdf
                that.pdf_pages = that.pdfDoc.numPages
                that.$nextTick(() => {
                    that._renderPage(1)
                })
            })
        },
        _renderPage (num) {
            let that = this
            that.pdfDoc.getPage(num).then((page) => {
                let canvas = document.getElementById('the_canvas' + num)
                let ctx = canvas.getContext('2d')
                let dpr = window.devicePixelRatio || 1
                let bsr = ctx.webkitBackingStorePixelRatio ||
                    ctx.mozBackingStorePixelRatio ||
                    ctx.msBackingStorePixelRatio ||
                    ctx.oBackingStorePixelRatio ||
                    ctx.backingStorePixelRatio || 1
                let ratio = 1 / bsr
                let viewport = page.getViewport({ scale: that.pdf_scale })
                that.width_img = canvas.width = viewport.width
                that.height_img = canvas.height = viewport.height;
                that.pdf_div_width = window.innerWidth + 'px'
                ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
                let renderContext = {
                    canvasContext: ctx,
                    viewport: viewport
                }
                page.render(renderContext);
                if (that.pdf_pages > num) {
                    that._renderPage(num + 1);

                }
            })
        },
        bigImg (el) {
            let that = this;
            that.items[0].w = el.target.getAttribute('widths');
            that.items[0].h = el.target.getAttribute('heights');
            console.log(el.target.getAttribute('index'));
            that.items[0].src = document.getElementById('the_canvas' + el.target.getAttribute('index')).toDataURL("image/png");
            that.bigImg_show = true;
        },
        close (e) {
            this.bigImg_show = e;
        },
    }
}
</script>
<style scoped>
.home_wrap {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}

.pdf_down {
    position: fixed;
    display: flex;
    z-index: 20;
    right: 26px;
    bottom: 7%;
}

.pdf_set_left {
    width: 30px;
    height: 40px;
    color: #408fff;
    font-size: 11px;
    padding-top: 25px;
    text-align: center;
    margin-right: 5px;
    cursor: pointer;
}

.pdf_set_middle {
    width: 30px;
    height: 40px;
    color: #408fff;
    font-size: 11px;
    padding-top: 25px;
    text-align: center;
    margin-right: 5px;
    cursor: pointer;
}

canvas {
    width: 100% !important;
    height: auto !important;
}

.img {
    width: 100%;
}

.img img {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/meetingL/pdf.vue